import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";

if (!process.env.REACT_APP_BACKEND_URL.includes("localhost")) {
  Sentry.init({
    dsn: "https://dfdbd485a469f0feb3b6cd9589080769@o4506629736300544.ingest.us.sentry.io/4511137383841792",
    integrations: [
      new BrowserTracing(),
    ],
    tracesSampleRate: 0.2,
    debug: false,
    environment: process.env.REACT_APP_BACKEND_URL?.split(/uat|dev/)?.length > 1 ? "DEV" : "PROD",
  });
  Sentry.captureMessage("Sentry initialized test")
}

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
